/**
 * Builds a [yes, no, yes, no, ...] conid array from conidExPairs for position lookups.
 * PositionBadge uses even indices as yes-side and odd indices as no-side.
 */
export function conidExPairsToPositionConids(
  conidYes: number,
  conidNo: number,
  yesConidExPairs?: string[],
  noConidExPairs?: string[],
): number[] {
  if (!yesConidExPairs || !noConidExPairs) {
    return [conidYes, conidNo];
  }
  const conids: number[] = [];
  const len = Math.max(yesConidExPairs.length, noConidExPairs.length);
  for (let i = 0; i < len; i++) {
    conids.push(i < yesConidExPairs.length ? parseInt(yesConidExPairs[i], 10) : conidYes);
    conids.push(i < noConidExPairs.length ? parseInt(noConidExPairs[i], 10) : conidNo);
  }
  return conids;
}
